export const FETCH_RECORDS = 'FETCH_RECORDS';
export const FETCH_RECORDS_OK = 'FETCH_RECORDS_OK';
export const FETCH_RECORDS_FAILED = 'FETCH_RECORDS_FAILED';